import { render, staticRenderFns } from "./PdpVideo.vue?vue&type=template&id=5dccadd8&scoped=true&"
import script from "./PdpVideo.vue?vue&type=script&lang=js&"
export * from "./PdpVideo.vue?vue&type=script&lang=js&"
import style0 from "./PdpVideo.vue?vue&type=style&index=0&id=5dccadd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dccadd8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLiteVideo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppLiteVideo.vue').default})
